/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Questionnaire_Editor_QuestionsInputs */

const en_admin_questionnaire_editor_questions = /** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const de_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const es_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const fr_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const it_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const pt_br2_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const pl_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const hu_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/** @type {(inputs: Admin_Questionnaire_Editor_QuestionsInputs) => LocalizedString} */
const ro_admin_questionnaire_editor_questions = en_admin_questionnaire_editor_questions;

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Admin_Questionnaire_Editor_QuestionsInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_questionnaire_editor_questions = /** @type {((inputs?: Admin_Questionnaire_Editor_QuestionsInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Questionnaire_Editor_QuestionsInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_questionnaire_editor_questions(inputs)
	if (locale === "de") return de_admin_questionnaire_editor_questions(inputs)
	if (locale === "es") return es_admin_questionnaire_editor_questions(inputs)
	if (locale === "fr") return fr_admin_questionnaire_editor_questions(inputs)
	if (locale === "it") return it_admin_questionnaire_editor_questions(inputs)
	if (locale === "pt-BR") return pt_br2_admin_questionnaire_editor_questions(inputs)
	if (locale === "pl") return pl_admin_questionnaire_editor_questions(inputs)
	if (locale === "hu") return hu_admin_questionnaire_editor_questions(inputs)
	return ro_admin_questionnaire_editor_questions(inputs)
});
export { admin_questionnaire_editor_questions as "admin.questionnaire_editor.questions" }